"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function pagesVisited(criteria, services, sessionManager) {
    var value = criteria[0].values[0];
    if (!value)
        return true;
    var currentSession = sessionManager.currentSession;
    return value <= currentSession.pageViewCounter;
}
exports.default = pagesVisited;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicGFnZXNWaXNpdGVkLmpzIiwic291cmNlUm9vdCI6InNyYy8iLCJzb3VyY2VzIjpbInNyYy9saWIvc2VydmljZXMvdGFyZ2V0cy9wYWdlc1Zpc2l0ZWQudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7QUFJQSxTQUF3QixZQUFZLENBQ2hDLFFBQWtDLEVBQ2xDLFFBQXNCLEVBQ3RCLGNBQThCO0lBRTlCLElBQU0sS0FBSyxHQUFHLFFBQVEsQ0FBQyxDQUFDLENBQUMsQ0FBQyxNQUFNLENBQUMsQ0FBQyxDQUFXLENBQUE7SUFDN0MsSUFBSSxDQUFDLEtBQUs7UUFBRSxPQUFPLElBQUksQ0FBQTtJQUV2QixJQUFNLGNBQWMsR0FBRyxjQUFjLENBQUMsY0FBYyxDQUFBO0lBQ3BELE9BQU8sS0FBSyxJQUFJLGNBQWMsQ0FBQyxlQUFlLENBQUE7QUFDbEQsQ0FBQztBQVZELCtCQVVDIn0=